import { CellContext, Selected, SelectElement } from '@optimus-web/core';
import { listOptions } from '../sections';
import { isCheckInConfigurationValue } from '../utils';
import { CheckInColumnName } from '../types';
import { TableDataItem } from './types';
import { StaticVisibilityField } from './StaticVisibilityField';
import { getTooltipText } from './utils';

interface VisibilityActionProps extends CellContext<TableDataItem, unknown> {
    columnName: CheckInColumnName;
    isChecked: boolean;
}

export const VisibilityAction = (props: VisibilityActionProps) => {
    const current = props.row.original;
    const { columnName, isChecked } = props;
    const { isDisabled, setVisibilityData, type, field, isEditable } = current;
    const visibility = current.visibility[columnName];
    const tooltip = current.tooltip[columnName];

    const handleActionClick = (_e: React.ChangeEvent, value: Selected) => {
        if (isCheckInConfigurationValue(value)) {
            setVisibilityData({ type, value, columnName });
        }
    };

    const isColumnEditable = isEditable[columnName];

    if (!isColumnEditable && isChecked) {
        const customTooltip = getTooltipText({ type, columnName, tooltip, fieldName: field, visibility });

        return <StaticVisibilityField tooltipValue={customTooltip} visibilityValue={visibility} />;
    }

    return (
        <SelectElement
            disabled={!isColumnEditable || isDisabled || !isChecked}
            onChange={handleActionClick}
            searchValueMapper={(component) => component.props.searchValue ?? ''}
            selected={visibility}
            name={`guestCheckInFieldConfigurationTableItem-${columnName}`}
            sizeToAnchor={false}
        >
            {listOptions({ tooltipValue: tooltip, fieldName: field, isDisabled: !isChecked })}
        </SelectElement>
    );
};
